module.exports = __webpack_public_path__ + "img/operationRecord.2ee6af01.svg";